export class ScheduleUpdatedMessage {

}
